<template>
  <div>
    <pageheader :linkTo='linkTo'></pageheader>

    <img class="banner" src="../assets/make/home/banner.png">
    <div @click="startMake" class="btn">
      开始制作证件照
      <img style="width: 6.5%;margin-left: 4%" src="../assets/make/home/icon_start.png">
    </div>
    <div class="title">
      <div style="width: 25%;display: flex;justify-content: space-between">
        <img style="width:22%;height: 3.4vw" src="../assets/make/home/step_one.png">
        <div style="width: 70%;height: 3.4vw;display: flex;flex-direction: column;justify-content: center">
          <div class="title-font-1">上传图片</div>
          <div class="title-font-2">可选择电脑或者手机上传</div>
        </div>
      </div>
      <div style="width: 25%;display: flex;justify-content: space-between">
        <img style="width:22%;height: 3.4vw" src="../assets/make/home/step_two.png">
        <div style="width: 70%;height: 3.4vw;display: flex;flex-direction: column;justify-content: center">
          <div class="title-font-1">选择尺寸</div>
          <div class="title-font-2">一寸、二寸、小二寸等…</div>
        </div>
      </div>
      <div style="width: 25%;display: flex;justify-content: space-between">
        <img style="width:22%;height: 3.4vw" src="../assets/make/home/step_three.png">
        <div style="width: 70%;height: 3.4vw;display: flex;flex-direction: column;justify-content: center">
          <div class="title-font-1">编辑人像</div>
          <div class="title-font-2">底色、美颜、换正装</div>
        </div>
      </div>
      <div style="width: 25%;display: flex;justify-content: space-between">
        <img style="width:22%;height: 3.4vw" src="../assets/make/home/step_four.png">
        <div style="width: 70%;height: 3.4vw;display: flex;flex-direction: column;justify-content: center">
          <div class="title-font-1">付费下载</div>
          <div class="title-font-2">保存电子照，冲印纸质照片</div>
        </div>
      </div>
    </div>


    <div class="pic">
      <div style="width: 100%;padding-bottom: 3vw;color: #35315C;font-weight: bold">照片要求:</div>
      <div style="width: 21%;display: flex;align-items: center;flex-direction: column">
        <img src="../assets/make/home/1.png" style="width: 100%">
        <span style="font-size: 12px;transform: scale(0.7);width: 130%">1、请使用纯色墙面做背景,确保背景整洁</span>
      </div>
      <div style="width: 21%;display: flex;align-items: center;flex-direction: column">
        <img src="../assets/make/home/2.png" style="width: 100%">
        <span style="font-size: 12px;transform: scale(0.7)">2、请保持拍照环境的光线均匀</span>
      </div>
      <div style="width: 21%;display: flex;align-items: center;flex-direction: column">
        <img src="../assets/make/home/3.png" style="width: 100%">
        <span style="font-size: 12px;transform: scale(0.7)">3、正对镜头，双耳露出</span>
      </div>
      <div style="width: 21%;display: flex;align-items: center;flex-direction: column">
        <img src="../assets/make/home/4.png" style="width: 100%">
        <span style="font-size: 12px;transform: scale(0.7)">4、发型整洁，淡妆最适宜</span>
      </div>
    </div>
    <pagefooter1></pagefooter1>
    <AgreementDialog @close="closeAgreementDialog" v-show="agreementDialogShow"></AgreementDialog>
  </div>
</template>

<script>
  import AgreementDialog from "../components/AgreementDialog";
    export default {
        name: "MakeHome",
        metaInfo: {
            title:'证件照在线制作-在线换底色-最美证件照',
            meta: [

                { name: 'title', content: '证件照在线制作-在线换底色-最美证件照' },
                { name: 'description', content:'最美证件照在线制作，支持多尺寸证件照制作，多套正装拍摄模板，符合计算机等级考试,四六级,国考,会计,教师资格证考试报名照片,简历照,工作证等各类尺寸.'},
                { name: 'keywords', content:'证件照在线制作,在线换底色,最美证件照'},
            ]
        },
        components:{AgreementDialog},
        data(){
            return {
                agreementDialogShow:false
            }
        },
        created() {
            this.linkTo=this.$route.path.substr(1)
        },
        methods:{
            closeAgreementDialog(flag){
                this.agreementDialogShow = flag
            },

            startMake(){
                this.agreementDialogShow=true
            },

        }
    }
</script>

<style scoped>
  .banner{
    width: 100%;
    position: relative;
    z-index: 1;
    padding-top:90px ;

  }
  .btn{
    width: 17.86vw;
    height: 3.6vw;
    border-radius: 1.8vw;
    background-image: linear-gradient(#9158D7,#782AD3);
    color: white;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    top: -11vw;
    z-index: 2;
    left: 19vw;
    cursor: pointer;
  }
  .title{
    width: 60vw;
    left: 19%;
    position: relative;
    height: 8.7vw;
    box-shadow: 0px 0px 10px rgba(142,109,124,0.2);
    z-index: 2;
    background-color: white;
    top:-8vw;
    border-radius: 8px;
    padding-left: 2vw;
    display: flex;
    align-items: center;
  }

  .title-font-1{
    font-size: 12px;color: #35315C;line-height: 20px;font-weight: bold
  }

  .title-font-2{
    font-size: 12px;color: rgba(53, 49, 92, 0.6);zoom: 0.8
  }

  .pic{
    width: 62vw;
    height: 16.59vw;
    left: 19vw;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    position: relative;
    top: -5vw;
    padding-bottom: 5vw;
  }



</style>
